import React from "react";
import { Mail, Phone } from "lucide-react";
import { useTheme } from "./../../Context/Theme";

const Footer = () => {
  const { themeData, getThemeLogo, isShowPartnershipLogo } = useTheme();
  const dynamicLogo = getThemeLogo();
  return (
    // hidden lg:block
    <footer className="px-6 xl:px-40 xl:h-[56px]  w-full border-t border-gray-200 bg-white  py-3">
      <div className="flex flex-col items-center justify-center gap-2 space-y-4 md:items-center md:justify-between md:flex-row md:space-y-0">
        <div className="flex flex-wrap items-center justify-center order-2 gap-2 text-sm md:order-1 text-greyish">
          <span>©Borderless 2025,</span>
          <span>All Rights Reserved </span>
          <a
            href={themeData?.data?.siteDisclaimer}
            target="_blank"
            rel="noreferrer"
            className="cursor-pointer text-blueish hover:text-blue-700"
          >
            Disclaimer
          </a>
        </div>
        {/* In partnership with section */}
        {dynamicLogo && isShowPartnershipLogo && (
          <div className="flex items-center justify-center gap-3 mt-8 ">
            <p className="text-[14px] md:text-[16px] font-geomanistRegular text-greyish">
              In partnership with
            </p>
            <img
              src={dynamicLogo}
              alt="Partner Logo"
              className="w-[60px] md:w-[80px] lg:w-[100px]"
            />
          </div>
        )}

        {/* Contact Information */}
        <div className="flex flex-wrap items-center justify-center order-1 gap-2 text-sm md:order-2 md:gap-6 text-greyish">
          {/* Email */}
          <a
            href={`mailto:${themeData?.data?.senderEmail}`}
            className="flex items-center gap-2 hover:text-gray-800"
          >
            <Mail className="w-4 h-4" />
            Email ID: {themeData?.data?.senderEmail}
          </a>

          {/* Phone */}
          <a
            href={`tel:${themeData?.data?.supportPhone}`}
            className="flex items-center gap-2 hover:text-gray-800"
          >
            <Phone className="w-4 h-4" />
            <span>Priority Hotline: {themeData?.data?.supportPhone}</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
